// Swiper is loaded globally via the CDN swiper-bundle in _LayoutFrontend (all modules
// pre-registered), so the public site doesn't pull a second copy through the build.
declare const Swiper: any;
import { quoteStore, langPrefix } from "../Quote/quoteStore";


document.addEventListener('DOMContentLoaded', () => {
    setupProductDetails();
    setupQuoteQty();
    setupAddAndGo();
});

// The detail page has a quantity stepper next to "Add to Quote". Keep the
// stepper value mirrored onto the button's data-product-qty so the global
// QuoteCart handler picks up the chosen amount, and reflect the in-cart state.
function setupQuoteQty() {
    const stepper = document.querySelector<HTMLElement>(".pd__qty");
    const addBtn = document.querySelector<HTMLElement>(".pd__info [data-add-to-quote]");
    if (!addBtn) return;

    const productId = Number(addBtn.getAttribute("data-product-id"));

    if (stepper) {
        const input = stepper.querySelector<HTMLInputElement>(".qcart-stepper__val");
        const clamp = (n: number) => Math.min(Math.max(isNaN(n) ? 1 : n, 1), 999);
        const sync = () => {
            if (!input) return;
            const v = clamp(parseInt(input.value, 10));
            input.value = String(v);
            addBtn.setAttribute("data-product-qty", String(v));
        };
        stepper.querySelector("[data-dec]")?.addEventListener("click", () => {
            if (input) input.value = String(clamp(parseInt(input.value, 10) - 1));
            sync();
        });
        stepper.querySelector("[data-inc]")?.addEventListener("click", () => {
            if (input) input.value = String(clamp(parseInt(input.value, 10) + 1));
            sync();
        });
        input?.addEventListener("change", sync);
        sync();
    }

    const reflect = () => addBtn.classList.toggle("is-added", productId > 0 && quoteStore.has(productId));
    quoteStore.subscribe(reflect);
    reflect();
}


function setupAddAndGo() {
    const btn = document.querySelector<HTMLButtonElement>("[data-add-and-go]");
    if (!btn) return;
    // The view renders data-add-and-go through Url.Loc, so it already carries /ar or /fr.
    // The fallback mirrors that rather than hardcoding the English path.
    const dest = btn.getAttribute("data-add-and-go") || (langPrefix() + "/quote");
    btn.addEventListener("click", () => {
        const addBtn = document.querySelector<HTMLElement>(".pd__info [data-add-to-quote]");
        if (addBtn) addBtn.click();
        // small delay so quoteStore updates before navigation
        setTimeout(() => { window.location.href = dest; }, 80);
    });
}

function setupProductDetails() {
    const curEl = document.querySelector<HTMLElement>(".pd__gi-cur");
    const pad = (n: number) => String(n).padStart(2, "0");
    const productDetailsSwiper = new Swiper(".product-details-swiper", {
        autoplay: {
            delay: 10000
        },
        slidesPerView: 1,
        loop: true,
        navigation: {
            nextEl: '.product-swiper-button-next',
            prevEl: '.product-swiper-button-prev',
        },
        pagination: {
            el: ".product-details-pagination",
            clickable: true,
        },
        observer: true,
        observeParents: true,
        on: {
            init(sw) { if (curEl) curEl.textContent = pad(sw.realIndex + 1); },
            slideChange(sw) { if (curEl) curEl.textContent = pad(sw.realIndex + 1); },
        },
    });
}
 